import GroupButtons from "../../../ui/button/groupButtons";
import BaseStep from "./baseStep";
import { EPurchasePurpose } from "./types";

interface IAimStep {
  onPrevStep: () => void;
  onNexStep: () => void;
  onChange: (data: EPurchasePurpose, key: "aim") => void;
  isNextStepDisabled: boolean;
  data: EPurchasePurpose | null;
}

const AimStep = ({
  onPrevStep,
  onNexStep,
  onChange,
  isNextStepDisabled,
  data,
}: IAimStep) => {
  const handleChange = (data: EPurchasePurpose) => {
    onChange(data, "aim");
  };

  return (
    <BaseStep
      prevStep={onPrevStep}
      nextStep={onNexStep}
      isNextStepDisabled={isNextStepDisabled}
      text="Цель приобретения квартиры?"
    >
      <GroupButtons
        data={[
          {
            onClick: () => handleChange(EPurchasePurpose.ChangeLocation),
            label: "Сменить локацию",
            variant:
              data === EPurchasePurpose.ChangeLocation
                ? "dark"
                : "lightDark",
          },
          {
            onClick: () => handleChange(EPurchasePurpose.DecreaseArea),
            label: "Уменьшить площадь квартиры",
            variant: data === EPurchasePurpose.DecreaseArea? "dark" : "lightDark",
          },
          {
            onClick: () => handleChange(EPurchasePurpose.IncreaseArea),
            label: "Увеличить площадь квартиры",
            variant: data === EPurchasePurpose.IncreaseArea ? "dark" : "lightDark",
          },
        ]}
      />
    </BaseStep>
  );
};

export default AimStep;
